import { render } from "./PageButton.vue?vue&type=template&id=21028cf2&scoped=true"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"

import "./PageButton.vue?vue&type=style&index=0&id=21028cf2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21028cf2"]])

export default __exports__